import React from 'react';
import {NavLink} from 'react-router-dom'
import {InstagramGreyIcon, TwitterGreyIcon, FacebookGreyIcon} from 'components/vectors'
import {ReactComponent as LogoInverse} from 'assets/images/svg/logo-inverse.svg';


const CommonFooter = () => {
    return (
        <div className="footer">
            <NavLink to="/"><LogoInverse /></NavLink>

            <div className="social">
                <NavLink to=""  className="mr-2"><FacebookGreyIcon /></NavLink>
                <NavLink to="" className="mr-2" ><TwitterGreyIcon /></NavLink>
                <NavLink to="" className=""><InstagramGreyIcon /> </NavLink>
            </div>
        </div>
        
    )
}

export default CommonFooter;